/* Natural Graze PDP results timeline (v21)
   Scroll-linked progress line + reveal, mirroring the reference behaviour.
   - Fills the orange progress line as the section scrolls through the viewport.
   - Reveals each week row (and pops its dot) when it crosses the mid line. */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('ng-timeline')) {
    return;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  customElements.define(
    'ng-timeline',
    class extends HTMLElement {
      connectedCallback() {
        this.weeks = Array.from(this.querySelectorAll('.pdp-timeline-v21__week'));
        if (!this.weeks.length) {
          return;
        }

        if (!reduceMotion.matches) {
          this.classList.add('is-animated');
        }

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        // Initial paint (rAF so layout is settled).
        requestAnimationFrame(this.update.bind(this));
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      onScroll() {
        var now = Date.now();
        if (now - (this.lastRun || 0) < 16) {
          return;
        }
        this.lastRun = now;
        this.update();
      }

      update() {
        var mid = window.innerHeight * 0.62;
        var box = this.getBoundingClientRect();

        if (box.height) {
          var fill = clamp((mid - box.top) / box.height, 0, 1);
          this.style.setProperty('--pt21-fill', fill.toFixed(4));
        }

        this.weeks.forEach(function (week) {
          var wb = week.getBoundingClientRect();
          week.classList.toggle('is-viewing', wb.top < mid);
        });
      }
    }
  );
})();
